import type { NeuralSentenceVoice } from "@-/dev.improve.haniverse.lib.sentence.speech.voice-catalog";

// The web keeps the browser's speech synthesis: neural voices need the native synthesizer.

export function canUseNeuralSentenceVoices(): boolean {
  return false;
}

export function isNeuralSentenceVoiceInstalled(_voice: NeuralSentenceVoice): boolean {
  return false;
}

export function getNeuralSentenceVoiceDownloadBytes(voice: NeuralSentenceVoice): number {
  return voice.bytes;
}

export function getNeuralSentenceVoiceFileUris(_voice: NeuralSentenceVoice): {
  model: string;
  modelUri: string;
  voiceUri: string;
} {
  throw new Error("On-device voices are not available on the web");
}

export function getSentenceVoiceStorageBytes(): number {
  return 0;
}

export function downloadNeuralSentenceVoice(
  _voice: NeuralSentenceVoice,
  _options: { onProgress?: (fraction: number) => void } = {},
): Promise<void> {
  return Promise.reject(new Error("On-device voices are not available on the web"));
}

export function removeNeuralSentenceVoices(): Promise<void> {
  return Promise.resolve();
}

export function isSentenceVoiceModelSuperseded(): boolean {
  return false;
}

export function upgradeSentenceVoiceModelOnWifi(): Promise<boolean> {
  return Promise.resolve(false);
}

export function onSentenceVoiceFilesChanged(_listener: () => void): () => void {
  return () => {};
}

export function refreshSentenceVoiceAssetPack(): Promise<void> {
  return Promise.resolve();
}
